export default {
  GET_NUMBERS_CARS_REQUEST: '@dashboard/GET_NUMBERS_CARS_REQUEST',
  GET_NUMBERS_CARS_SUCCESS: '@dashboard/GET_NUMBERS_CARS_SUCCESS',
};
